import React, { useContext, useEffect } from "react";
import { SurveyContext } from "../../../store/survey-context";
import Share from "../../../components/share/share.js";

export default function Finish() {
  const context = useContext(SurveyContext);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer?.push({
      event: "mtcExpFinish",
    });
    window.dataLayer?.push({
      event: "mtcExpScreen",
      screen: "Finish and share",
      step: 56,
    });
    if (window.hj) {
      window.hj("stateChange", "finish");
    }
  }, []);

  return <Share image={context.userProfile.mostRecentImageUrl} />;
}
